import React from 'react';
import Hide from '@uber/base-icons/hide';
import Show from '@uber/base-icons/show';
import { useStyletron } from 'baseui';
import { ICON_SIZE } from '../constants';
import type { ActionButtonPropsT } from '../types';
import { ActionButton } from './action-button';
export function ShowHideButton({
  annotation,
  onClick
}: ActionButtonPropsT) {
  const [, theme] = useStyletron();
  const isVisible = annotation.isVisible;
  return <ActionButton icon={isVisible ? <Show size={ICON_SIZE} color={theme.colors.contentPrimary} /> : <Hide size={ICON_SIZE} color={theme.colors.contentPrimary} />} name={isVisible ? 'Hide Annotation' : 'Show Annotation'} onClick={onClick} tooltipContent={isVisible ? 'Hide Annotation' : 'Show Annotation'} />;
}